var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Playlist","active":""}},[(_vm.linked)?_c('b-form-group',[_c('button',{staticClass:"flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]",on:{"click":() => _vm.unlinkSid()}},[_vm._v(" Unlink Styles "),_c('i',{staticClass:"fa fa-link text-primary"})])]):_vm._e(),_c('b-form-group',[_c('draggable',{attrs:{"handle":".move"},model:{value:(_vm.section.options.content.playlist.items),callback:function ($$v) {_vm.$set(_vm.section.options.content.playlist, "items", $$v)},expression:"section.options.content.playlist.items"}},[_c('transition-group',{attrs:{"name":"shufle"}},_vm._l((_vm.section.options.content.playlist.items),function(item,index){return _c('mod-drag-item',{key:`key-${index}`,attrs:{"item":item,"active":_vm.active === index},on:{"open":() => _vm.active = index,"delete":() => _vm.deleteItem(index)},scopedSlots:_vm._u([{key:"active",fn:function(){return [_c('rule-tabs',{attrs:{"tabs":['Simple', 'Advanced']},scopedSlots:_vm._u([{key:"Simple",fn:function(){return [_c('div',{staticClass:"pt-2"},[_c('b-form-group',{attrs:{"label":"Insert Video"}},[_c('v-select',{attrs:{"searchable":false,"options":[
                          'ESTAGE',
                          'External URL'
                        ]},model:{value:(item.videoType),callback:function ($$v) {_vm.$set(item, "videoType", $$v)},expression:"item.videoType"}})],1),(item.videoType === 'ESTAGE')?_c('sid-upload-video',{attrs:{"index":index,"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"url"},on:{"uploaded-video":function($event){return _vm.loadVideo(index, $event)},"uploaded-preview":function($event){return _vm.loadPreview(index, $event)}}}):(item.videoType === 'External URL')?_c('b-form-group',{attrs:{"label":"Video URL"}},[_c('b-input',{on:{"input":function($event){return _vm.loadPreview(index)}},model:{value:(item.url),callback:function ($$v) {_vm.$set(item, "url", $$v)},expression:"item.url"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Start Time"}},[_c('b-input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.timeMask),expression:"timeMask"}],attrs:{"placeholder":"00:00:00"},model:{value:(item.start),callback:function ($$v) {_vm.$set(item, "start", $$v)},expression:"item.start"}})],1),_c('b-form-group',{attrs:{"label":"Title"}},[_c('b-input',{model:{value:(item.title),callback:function ($$v) {_vm.$set(item, "title", $$v)},expression:"item.title"}})],1),_c('b-form-group',{attrs:{"label":"Description"}},[_c('b-textarea',{staticClass:"min-h-[150px]",model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_c('b-form-group',{attrs:{"label":"Preview"}},[_c('image-upload',{attrs:{"image":item,"disable-settigns":""}})],1)],1)]},proxy:true},{key:"Advanced",fn:function(){return [_c('b-form-group',{attrs:{"label":"Connect tabs element"}},[_c('pick-element',{attrs:{"allow-picks":['ElGridCollapseV3'],"grab-all":true},model:{value:(_vm.section.options.content.playlist),callback:function ($$v) {_vm.$set(_vm.section.options.content, "playlist", $$v)},expression:"section.options.content.playlist"}})],1),(_vm.section.options.content.playlist.subject)?_c('v-select',{attrs:{"options":_vm.section.options.content.playlist.subject.gridCollapse.items.filter(item => item.hash),"reduce":tab => tab.hash,"label":"title"},model:{value:(item.custom_url),callback:function ($$v) {_vm.$set(item, "custom_url", $$v)},expression:"item.custom_url"}}):_vm._e()]},proxy:true}],null,true)})]},proxy:true}],null,true)})}),1)],1)],1),_c('button',{staticClass:"flex items-center border gap-[5px] rounded-[4px] font-[600] text-dark !text-[11px] h-[29px] px-[18px] shadow-[0_2px_3px_rgba(0, 0, 0, 0.06)] mb-[25px]",on:{"click":_vm.addSlide}},[_vm._v(" Add Item "),_c('span',{staticClass:"text-[#3D82EA] text-[20px]"},[_vm._v("+")])]),_c('b-form-group',{attrs:{"label":"Connect video element"}},[_c('pick-element',{attrs:{"allow-picks":['ElVideoV2']},model:{value:(_vm.section),callback:function ($$v) {_vm.section=$$v},expression:"section"}})],1),_c('sid-flex-direction',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"flex-direction"}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}--playlist`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Width","var":"--width","measurement":"width"}})],1),_c('sid-range-slider',{attrs:{"rule-name":"height","sid":`.--${_vm.section.sid}--playlist`,"default-dimension":"%","dimensions":['%', 'vh', 'px'],"label":"Height","var":"--height","measurement":"height"}}),_c('sid-range-slider',{attrs:{"label":"Gap","sid":`.--${_vm.section.sid}--playlist`,"rule-name":"gap","dimensions":[]}}),_c('b-form-group',[_c('label',{staticClass:"mb-0"},[_vm._v(" Overflow "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.topright.hover",modifiers:{"topright":true,"hover":true}}],staticClass:"fa fa-question-circle cursor-pointer hover:text-blue-500 ml-1",attrs:{"title":"Relevant for fixed height only."}})]),_c('b-form-group',[_c('sid-select',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"overflow","options":[{label: 'Scroll', value: 'auto'}, {label: 'Visible', value: ''}]}})],1)],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Playlist Item"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Hover', 'Active']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}--playlist-item`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Width","var":"--width","measurement":"width"}})],1),_c('sid-range-slider',{attrs:{"rule-name":"height","sid":`.--${_vm.section.sid}--playlist-item`,"default-dimension":"%","dimensions":['%', 'vh', 'px'],"label":"Height","var":"--height","measurement":"height"}}),_c('sid-flex-direction',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"flex-direction"}}),_c('b-form-group',[_c('sid-buttons-group',{attrs:{"label":"Alignment","options":[
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'10\' viewBox=\'0 0 16 10\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'2.54688\' y=\'1.59863\' width=\'4.1387\' height=\'7.67361\' fill=\'%237E7E7E\'/%3E%3Crect x=\'7.32251\' y=\'1.59863\' width=\'4.1387\' height=\'5.43547\' fill=\'%237E7E7E\'/%3E%3Crect width=\'15.2814\' height=\'0.959201\' transform=\'matrix(1 0 0 -1 0 0.958984)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'start',
                tooltip: 'Start'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'9\' viewBox=\'0 0 16 9\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'2.87305\' y=\'0.349243\' width=\'4.05866\' height=\'8.46585\' fill=\'%237E7E7E\'/%3E%3Crect x=\'7.55664\' y=\'0.976318\' width=\'4.05866\' height=\'6.8981\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.9858\' height=\'0.94065\' transform=\'matrix(1 0 0 -1 0.0634766 5.05249)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'center',
                tooltip: 'Center'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'10\' viewBox=\'0 0 16 10\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.0532\' height=\'7.51508\' transform=\'matrix(1 -8.77996e-08 -8.70476e-08 -1 3.43945 7.86438)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.0532\' height=\'5.32318\' transform=\'matrix(1 -8.77996e-08 -8.70476e-08 -1 8.11523 7.86438)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.9657\' height=\'0.939385\' transform=\'matrix(1 0 0 -1 0.632812 9.43018)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'end',
                tooltip: 'End'
              }
            ],"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"align-items"}})],1),_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"text-align","label":"Text Alignment"}}),_c('sid-range-slider',{attrs:{"label":"Gap","sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"gap","dimensions":[]}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"box-shadow"}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"label":"Border Width","rule-name":"border","css-var":"--border-size","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item`,"rule-name":"box-shadow","presudo":":hover"}})],1)]},proxy:true},{key:"Active",fn:function(){return [_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item.active`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item.active`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--playlist-item.active`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item.active`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--playlist-item.active`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('b-form-group',{attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--playlist-item.active`,"rule-name":"box-shadow"}})],1),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--playlist-item.active`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Title Style"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Active']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-checkbox',{attrs:{"sid":`.--${_vm.section.sid}--title`,"rule-name":"display","value":"none","unchecked-value":""}},[_vm._v(" Hide ")]),_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--title`,"rule-name":"color"}})],1)]),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--title`,"rule-name":"color"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid}--title`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.section.sid}--title`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--title`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Active",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Color")]),_c('sid-color',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--title`,"rule-name":"color"}})],1)]),_c('sid-font',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--title`,"rule-name":"color"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.video-playlist-item.active .--${_vm.section.sid}--title`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Description Style"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Active']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-checkbox',{attrs:{"sid":`.--${_vm.section.sid}--description`,"rule-name":"display","value":"none","unchecked-value":""}},[_vm._v(" Hide ")]),_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--description`,"rule-name":"color"}})],1)]),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--description`,"rule-name":"color"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.section.sid}--description`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.section.sid}--description`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--description`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Active",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Color")]),_c('sid-color',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--description`,"rule-name":"color"}})],1)]),_c('sid-font',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--description`,"rule-name":"color"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.video-playlist-item.active .--${_vm.section.sid}--description`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Thumbnail"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Active']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-checkbox',{attrs:{"sid":`.--${_vm.section.sid}--preview`,"rule-name":"display","value":"none","unchecked-value":""}},[_vm._v(" Hide ")]),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--preview .block-bg`}}),_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--preview`,"rule-name":"color"}})],1)]),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"font-size","sid":`.--${_vm.section.sid}--preview`,"default-dimension":"px","dimensions":['px'],"label":"Icon Size"}})],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}--preview`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Width","var":"--width","measurement":"width"}})],1),_c('sid-range-slider',{attrs:{"rule-name":"height","sid":`.--${_vm.section.sid}--preview`,"default-dimension":"%","dimensions":['%', 'vh', 'px'],"label":"Height","var":"--height","measurement":"height"}}),_c('b-form-group',{attrs:{"label":"Background Image Size"}},[_c('sid-select',{attrs:{"priority":"","searchable":false,"options":[
              {
                label: 'Cover',
                value: 'cover',
                customProperties: [[`.--${_vm.section.sid}--preview`, ['background-size', 'cover']], [`.--${_vm.section.sid}--preview`, ['background-attachment', 'unset']]]
              },
              {
                label: 'Contain',
                value: 'contain',
                customProperties: [[`.--${_vm.section.sid}--preview`, ['background-size', 'contain']], [`.--${_vm.section.sid}--preview`, ['background-attachment', 'unset']]]
              }
            ],"sid":`.--${_vm.section.sid}--preview`,"var":"--background-size","rule-name":"background-size"}})],1),_c('b-form-group',{attrs:{"label":"Background Image Position"}},[_c('sid-select',{attrs:{"searchable":false,"options":[
              {label: 'Left Top', value: 'left top'},
              {label: 'Left Center', value: 'left center'},
              {label: 'Left Bottom', value: 'left bottom'},
              {label: 'Right Top', value: 'right top'},
              {label: 'Right Center', value: 'right center'},
              {label: 'Right Bottom', value: 'right bottom'},
              {label: 'Center Top', value: 'center top'},
              {label: 'Center Center', value: 'center center'},
              {label: 'Center Bottom', value: 'center bottom'},
            ],"sid":`.--${_vm.section.sid}--preview`,"rule-name":"background-position"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--preview`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--preview`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--preview`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--preview`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--preview`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Active",fn:function(){return [_c('sid-background',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--preview .block-bg`}}),_c('b-form-group',[_c('div',{staticClass:"flex gap-[10px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"rule-name":"color"}})],1)]),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"font-size","sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"default-dimension":"px","dimensions":['px'],"label":"Icon Size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.video-playlist-item.active .--${_vm.section.sid}--preview`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"box-shadow"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"box-shadow","presudo":":hover"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--playlist`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--playlist`,"label":"Border Width","rule-name":"border","css-var":"--border-size","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--playlist`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--playlist`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--playlist`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }